export const INPUT_FIELDS_MAX_LENGTH = {
    NAME: 50,
    CLIENT: 30,
    DESCRIPTION: 3000,
    POSITION: 100,
};
